import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchBijlagenForEntity,
  initialState,
} from '../services/fetchBijlagenForEntity'

export { useBijlagenForEntity, queryKey }

const queryKey = 'entity-bijlagen'

const useBijlagenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchBijlagenForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialState.data,
  }
}
